import angular from 'angular';
import ngeoGooglestreetviewComponent from 'ngeo/googlestreetview/component.js';

/**
 * @type {!angular.IModule}
 */
export default angular.module('ngeoGooglestreetviewModule', [
  ngeoGooglestreetviewComponent.name
]);
